import { useParams } from "react-router-dom";
import { useAppSelector } from "store/store";

export const useLanguagePath = () => {
  const { lang } = useParams<{ lang?: string }>();
  const { current } = useAppSelector((state) => state.language);
  
  // Use URL lang if available, otherwise use Redux current, default to 'en'
  const activeLang = lang || current || "en";

  return (path: string) => {
    // Handle root path
    if (path === "/") {
      return `/${activeLang}`;
    }
    // Ensure path starts with /
    const cleanPath = path.startsWith("/") ? path : `/${path}`;
    return `/${activeLang}${cleanPath}`;
  };
};